import type { FieldError as HookFieldError } from "react-hook-form";
import FieldError from "./errors/FieldError.tsx";

export default function Checkbox({
	children,
	error,
	className,
	...props
}: React.PropsWithChildren<
	Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
		error?: HookFieldError;
	}
>) {
	const classes: string[] = [];
	if (error) classes.push("has-error");
	if (className) classes.push(className);
	return (
		<>
			<div className="checkbox">
				<input id={props.name} {...props} type="checkbox" />
				<label htmlFor={props.name}>{children}</label>
			</div>
			{error && <FieldError className="!pt-0 !-mt-1 pb-1" error={error} />}
		</>
	);
}
